<template>
  <div>
    <div class="container-fluid py-4 dashboard-hud d-md-block d-none">
      <div class="row">
        <div class="col-12">
          <div class="container">
            <div class="card-deck">
              <router-link :to="{path:'/Events', query: {statusType:statistic.statusType}}" class="card h-auto mb-md-0 mb-3" v-for="(statistic) in eventStatistics" v-bind:key="statistic.orderIndex">
                <b-badge id="status-badge" v-if="statistic.statusType===0" pill class="status-badge" variant="success" title="New Events">
                  NEW!
                </b-badge>
                <div class="card-body d-flex align-items-center justify-content-center">
                  <h6 class="m-0">
                    <span data-localize="display_name">{{statistic.displayName}}</span>
                    <span>{{statistic.eventCount}}</span>
                  </h6>
                </div>
              </router-link>
          </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="mt-5 shadow card p-5 mb-5 d-md-block d-none">
        <h5><strong>Event Details</strong></h5>
        <div>
          <chart v-if="loaded" :options="options" :chartdata="chartdata" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import chart from '../views/DashboardChart.vue'

export default {
  name: 'Dashboard',
  components: {
    chart
  },
  data () {
    return {
      eventReports: [],
      eventStatistics: [],
      datacollection: null,
      chartdata: null,
      options: null,
      loaded: false
    }
  },
  async created () {
    await this.loadDashboard()
  },
  mounted () {
  },
  methods: {
    ...mapActions('dashboard', ['getDashboard']),
    async loadDashboard () {
      // hack to gain global access to label data
      window.lastLabel = null
      window.typeOffsetIndexes = []
      var result = await this.getDashboard()
      if (result.status === 200) {
        this.eventReports = result.data.eventReports
        this.eventStatistics = result.data.eventStatistics
        var types = []
        var labels = []
        var datapoints = []
        this.eventReports.forEach((c, idx) => {
          types.push(c.type)

          c.eventCategoryReports.forEach((r) => {
            labels.push(`${c.type}:${r.category}`)
            let data = {t: `${c.type}:${r.category}`, y: r.eventCount}
            datapoints.push(data)
          })
        })

        this.chartdata = {
          labels: labels,
          datasets: [{backgroundColor: 'lightblue', data: datapoints, xAxisID: 'xAxis1'}]
        }
        this.options = {
          chartArea: {
            backgroundColor: 'rgba(251, 85, 85, 0.4)'
          },
          maintainAspectRatio: false,
          responsive: true,
          legend: {
            display: false,
            position: 'bottom'
          },
          title: {
            display: false,
            text: 'Total Events Reported to Date'
          },
          scales: {
            xAxes: [
              {
                id: 'xAxis2',
                offset: true,
                position: 'top',
                gridLines: {drawOnChartArea: true, tickMarkLength: 15, offsetGridLines: true, drawTicks: true, color: 'black'},
                type: 'category',
                ticks: {
                  labelOffset: 20,
                  xpadding: 5,
                  autoSkip: false,
                  beginAtZero: false,
                  minRotation: 45,
                  maxRotation: 45,
                  callback: (item, index, items) => {
                    // return item.split(':')[0]
                    var type = item.split(':')[0]
                    console.log(type, window.lastLabel)
                    if (type !== window.lastLabel) {
                      window.lastLabel = type
                      return `${type}`
                    } else {
                      return null
                    }
                  }
                }
              },
              {
                id: 'xAxis1',
                offset: true,
                gridLines: {drawOnChartArea: true, tickMarkLength: 15, offsetGridLines: true, drawTicks: true, drawBorder: true},
                type: 'category',
                ticks: {
                  autoSkip: false,
                  beginAtZero: true,
                  minRotation: 90,
                  maxRotation: 90,
                  callback: (item, index, items) => {
                    return `  ${item.split(':')[1]}`
                  }
                }
              }
            ]
          }
        }
        this.loaded = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cert {
  position: absolute;
  top: -2px;
  left: -2px;
  color: rgb(89, 165, 89);
}
.card-body > h5 {
  cursor: pointer;
  color: rgb(89, 165, 89);
  font-size: 1.8em;
  font-weight: 800;
  margin:.1em;
}
.dashboard-hud {
  position: absolute;
  top: 0px;
  width: calc(100% - 180px);
  background-color: #09253a;
}
.dashboard-hud .card{
  background: rgba(0,0,0,0.5);
  border-radius: 30px;
  margin: 0 25px;
  box-shadow: inset 0 1px 2px rgba(0,0,0,0.2), 0 1px 0 rgba(255,255,255,0.1);
  overflow: visible;
  -webkit-transition: ease-out 0.3s;
  -moz-transition: ease-out 0.3s;
  transition: ease-out 0.3s;
}
.dashboard-hud .card:hover{
  box-shadow: inset 400px 0 0 0 #007bff;
  color: #fff;
  text-decoration: none;
}
.dashboard-hud .card .card-body {
  -webkit-transition: ease-out 0.4s;
  -moz-transition: ease-out 0.4s;
  transition: ease-out 0.4s;
}
.dashboard-hud .card:hover .card-body{
  padding-left: 0 !important;
  margin-left: -15px;
}
.dashboard-hud .card:hover .card-body:after{
  font-family: "fontawesome";
  content: "\f061";
  width: 20px;
  height: 20px;
  display: block;
  right: 5px;
  position: absolute;
}
.dashboard-hud .status-badge {
  position: absolute;
  top: -5px;
  left: -1px;
  z-index: 100;
}
.statistics-container {
  background-color: #fff;
  border: 2px solid lightgray;
  border-radius: 10px;
  padding:.1em .7em 0;
}
.statistics-container > label {
  font-size: small;
  margin:.1em;
}

.statistics-container > h5 {
  color: rgb(89, 165, 89);
  font-weight: 800;
  margin:.1em;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue